import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "@app/modules/alert";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { BaseService } from "./base.service";
import { IFeedback, IFeedbackQueryOptions } from "@app/models/feedback";
import { PagingOpts } from "@app/models/common";
import { IWorkRequestQueryOptions } from "@app/models/work-request";

@Injectable({
    providedIn: "root",
})
export class FeedbackService extends BaseService  {
 
    url = this.getBaseURL() + "feedback";

    errorOptions = {
        autoClose: false,
        keepAfterRouteChange: false,
    };
    constructor(private http: HttpClient, private alertService: AlertService) {
        super();
    }

    getFeedback(pagingOpts: PagingOpts, opts: IFeedbackQueryOptions) {
        const url = this.getUrl(this.url , pagingOpts, opts);
        return this.http.get<IFeedback[]>(url.nextUrl , {headers: this.setCustomRequestheaders(),params: url.params} ).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    //this.errorMessage = error.message;
                    console.error("There was an error!", error.message);
                    this.alertService.error(
                        "Error loading data : " +
                            this.checkStatusCode(error),
                        this.errorOptions,
                        error
                    );

                    throw error;
                }
            )
        );
    }
    
    getFeedbackStats() {
       
        return this.http.get<IFeedback[]>(this.url + "/stats" , {headers: this.setCustomRequestheaders()} ).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    //this.errorMessage = error.message;
                    console.error("There was an error!", error.message);
                    this.alertService.error(
                        "Error loading data : " +
                            this.checkStatusCode(error),
                        this.errorOptions,
                        error
                    );

                    throw error;
                }
            )
        );
    }
    postfeedback(feedback: IFeedback) {
        const url = this.url;        
        return this.http.post<string[]>(url, feedback, {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (error): Observable<unknown> => {
                    /*
                    this.alertService.error(
                        "Error posting data to database : " +
                            this.checkStatusCode(error),
                        this.errorOptions
                    );
                    */
                    throw error;
                }
            )
        );
    }
    
    
}
